<script setup lang="ts">
import type { RadioGroupItemProps } from 'reka-ui'
import { RadioGroupIndicator, RadioGroupItem, useForwardProps } from 'reka-ui'

type Shade = 'light' | 'dark'

const props = withDefaults(defineProps<RadioGroupItemProps & { shade?: Shade }>(), {
  shade: 'dark'
})

const forwarded = useForwardProps(props)
</script>

<template>
  <div class="flex items-center gap-1.5">
    <RadioGroupItem
      v-bind="forwarded"
      class="size-5 cursor-default rounded-full border-2 bg-transparent transition-colors focus-visible:ring"
      :class="[
        shade === 'dark'
          ? 'border-green-40 hover:bg-green-40/10'
          : 'border-green-5 hover:bg-green-5/20',
      ]"
    >
      <RadioGroupIndicator
        class="relative flex h-full w-full items-center justify-center after:block after:size-2 after:rounded-full after:content-['']"
        :class="[
          shade === 'dark' ? 'after:bg-green-40' : 'after:bg-green-5',
        ]"
      />
    </RadioGroupItem>
    <label v-if="$slots.default" :for="id"><slot /></label>
  </div>
</template>
